
import { TranslateService } from '@ngx-translate/core';

export class SftpDashboardDetailHandler {
    constructor(    public translateService: TranslateService,
        ){

    }

}